import React from 'react';

type BenefitItem = {
  icon: string;
  title: string;
  description: string;
  highlight: string | React.ReactNode;
};

type BenefitsGridProps = {
  items: BenefitItem[];
  className?: string;
};

const BenefitsGrid: React.FC<BenefitsGridProps> = ({ items, className = '' }) => {
  return (
    <div className={`grid gap-8 md:grid-cols-3 mt-12 ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="flex flex-col shadow-lg p-4 rounded-lg">
          <div className="text-4xl mb-4">{item.icon}</div>
          <h3 className="text-xl font-bold mb-3">{item.title}</h3>
          <p className="text-gray-600 mb-4 flex-1">{item.description}</p>
          <p className="text-primary font-semibold">{item.highlight}</p>
        </div>
      ))}
    </div>
  );
};

export default BenefitsGrid;
